module.exports = __webpack_public_path__ + "static/media/cap3-leg-mob.1f7f4412.png";